import { listInterview } from "@endpoints/interview.service";
import dayjs from "@lib/dayjs";
import { useEffect, useState } from "react";

type EventType = {
  meetingTitle: string;
  _id: string;
  startTime: string | null;
  endTime: string | null;
};

function formatEvents(data) {
  let formattedEvents = {};

  data?.forEach((item) => {
    const dateString = dayjs(item?.endTime).format("YYYY-MM");
    formattedEvents[dateString] = [
      ...(formattedEvents[dateString] || []),
      item,
    ];
  });

  //Sort the keys and return a new object
  const sortedEvents = Object.keys(formattedEvents)
    .sort() // ascending order by date string
    .reverse()
    .reduce((acc, key) => {
      acc[key] = formattedEvents[key];
      return acc;
    }, {});

  return sortedEvents;
}

const useCalender = () => {
  const [events, setEvents] = useState<Record<string, EventType[]>>({});

  async function fetchMeetingList() {
    try {
      const { success, data } = await listInterview({ isSchedule: true });
      if (success) {
        console.log(data);
        const updatedEventList = data?.map((item) => {
          return {
            ...item?.specificSlot,
            meetingTitle: item?.meetingTitle,
            _id: item?._id,
          };
        });
        console.log(formatEvents(updatedEventList));
        setEvents(formatEvents(updatedEventList));
      }
    } catch (error) {
      console.error("Error: fetching meeting list for calendar view", error);
    }
  }

  useEffect(() => {
    fetchMeetingList();
  }, []);

  return {
    events,
  };
};

export default useCalender;
